import mock from '@/fake-db/mock.js'
import jwt from 'jsonwebtoken'

const data = {
  checkpointReward: {
    designName: 'John',
    progress: '57.6%'
  },
  designes: [
    {
      uid: 34,
      displayName: 'Howard Potts',
      password: 'adminadmin',
      photoURL: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      email: 'admin@admin.com',
      phoneNumber: null
    }
  ]
}


const jwtConfig = {
  'secret'   : 'dd5f3089-40c3-403d-af14-d0c228b05cb4',
  'expireTime': 8000
}


mock.onPost('/api/auth/login').reply((request) => {
  const {email, password} = JSON.parse(request.data)

  let error = 'Something went wrong'

  const design = data.designes.find(design => design.email === email && design.password === password)

  if (design) {

    try {

      const accessToken = jwt.sign({id: design.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

      const designData = Object.assign({}, design, {providerId: 'jwt'})

      delete designData.password

      const response = {
        designData,
        accessToken
      }

      return [200, response]

    } catch (e) {
      error = e
    }
  } else {
    error = 'Email Or Password Invalid'
  }

  return [200, {error}]


})

mock.onPost('/api/auth/register').reply((request) => {
  const {displayName, email, password} = JSON.parse(request.data)
  const isEmailAlreadyInUse = data.designes.find((design) => design.email === email)
  const error = {
    email      : isEmailAlreadyInUse ? 'This email is already in use.' : null,
    displayName: displayName === '' ? 'Please enter your name.' : null
  }

  if (!error.displayName && !error.email) {

    const designData = {
      email,
      password,
      displayName,
      photoURL: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      phoneNumber: null
    }

    // Add design id
    const length = data.designes.length
    let lastIndex = 0
    if (length) {
      lastIndex = data.designes[length - 1].uid
    }
    designData.uid = lastIndex + 1

    data.designes.push(designData)

    const accessToken = jwt.sign({id: designData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

    const design = Object.assign({}, designData)
    delete design['password']
    const response = {
      designData: design,
      accessToken
    }

    return [200, response]
  } else {
    return [200, {error}]
  }
})


mock.onPost('/api/auth/refresh-token').reply((request) => {

  const {accessToken} = JSON.parse(request.data)

  try {
    const {id} = jwt.verify(accessToken, jwtConfig.secret)

    const designData = Object.assign({}, data.designes.find(design => design.uid === id))

    const newAccessToken = jwt.sign({id: designData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expiresIn})

    delete designData['password']
    const response = {
      designData,
      accessToken: newAccessToken
    }

    return [200, response]
  } catch (e) {
    const error = 'Invalid access token'
    return [401, {error}]
  }
})


mock.onGet('/api/design/checkpoint-reward').reply(() => {
  return [200, data.checkpointReward]
})
